import CommonState from './CommonState'

/**
 * 节点前置审批条件
 */

export const CHARGE_BILL_DOC_EXPORTED = new CommonState('CHARGE_BILL_DOC_EXPORTED', '费用凭证已导出', 'Expense proof has been exported')

export const PRE_CRITERIA = new Set([
  CHARGE_BILL_DOC_EXPORTED
])

